import { doodBlockConfig } from './dood-block-config';
import {
  buildOrderedBlockDescriptor,
  type DescriptorFieldOrderItem,
} from './descriptor-field-order';
import type { IBlockDescriptor } from './descriptor';

export const FAVORITESPAGE_LEGACY_FIELD_ORDER = [
  
] as const satisfies readonly DescriptorFieldOrderItem[];

const {
  favoritesPageDescriptor: _generatedFavoritesPageDescriptor,
  favoritesPageBlocDefinition,
  favoritesPageDashboardLayout,
  favoritesPageConfig,
  favoritesPageResolveConfig,
  favoritesPageProperties,
} = doodBlockConfig(
  {
    name: "Favorite shops page",
    internal_name: "Favorite shops page",
    url: "favorites",
    defaultParent: [/^Main Layout$/i],
    componentType: 'FavoritesPageComponent',
    category: 'page',
    description: "Favorite shops page.",
    keywords: [],
    isRootBlock: true,
    sharedFields: {}
,
    slots: [
      {
        key: 'body',
        name: "pages.blocks.favorites-page.body.label",
        accept: 'explicitOnly',
        allowedTypes: [".*(?<!Page)"],
        slotItemFormat: 'ids',
      },
      {
        key: 'footer',
        name: "pages.blocks.favorites-page.footer.label",
        accept: 'explicitOnly',
        allowedTypes: ["BigFooterBlock", "LegalsFooterBlock", "HtmlBlock"],
        slotItemFormat: 'ids',
      }
    ]
  },

  () => ({
    // no scalar props
  }),

  () => ({
    tabs: [
      {
        label: "pages.blocks.favorites-page.tab.content.label",
        fieldsets: [
          {
            legend: "pages.blocks.favorites-page.fieldset.blocks.label",
            fields: ["body", "footer"],
          },
        ],
      },
    ],
  })
);

export function favoritesPageDescriptor(): IBlockDescriptor;
export function favoritesPageDescriptor(
  fieldOrder: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor;
export function favoritesPageDescriptor(
  fieldOrder?: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor {
  if (fieldOrder === undefined) {
    return _generatedFavoritesPageDescriptor;
  }
  return buildOrderedBlockDescriptor(_generatedFavoritesPageDescriptor, favoritesPageProperties, fieldOrder);
}

export {
  favoritesPageBlocDefinition,
  favoritesPageDashboardLayout,
  favoritesPageProperties,
  favoritesPageConfig,
  favoritesPageResolveConfig,
};

export type FavoritesPageConfig = typeof favoritesPageConfig;
